import { combineReducers } from 'redux';
import objReducer from './dataReducer';
import sessionReducer from './sessionReducer';

export default combineReducers({
  obj: objReducer,
  session: sessionReducer,
});
